import React from "react";
import Navigation from "../partials/Navigation";

const Profile = () => {

    return (
        <div className="main-wrapper">
            <Navigation />
            <h1>User Profile</h1>
        </div>
    );

}

export default Profile;